const CloseSelect = () => {
    return (
        <svg width="8px" height="8px" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="权限管理与通知" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
                <g id="页面分享04" transform="translate(-1411.000000, -232.000000)" stroke="#4E4F52">
                    <g id="编组-23备份-5" transform="translate(1335.000000, 142.000000)">
                        <g id="编组-24" transform="translate(20.000000, 78.000000)">
                            <g id="编组-12" transform="translate(10.000000, 6.000000)">
                                <g id="编组" transform="translate(46.000000, 6.000000)">
                                    <g id="删除标签" transform="translate(1.500000, 1.500000)">
                                        <line x1="0.5" y1="0.5" x2="4.70166016" y2="4.70166016" id="直线"></line>
                                        <line
                                            x1="0.5"
                                            y1="0.5"
                                            x2="4.70166016"
                                            y2="4.70166016"
                                            id="直线"
                                            transform="translate(2.500000, 2.500000)
                                            scale(-1, 1) translate(-2.500000, -2.500000)"
                                        ></line>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default CloseSelect;
